export default "__VITE_ASSET__qGPWFaE$__"